var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"kvWrapper",class:[
    'kv-wrapper',
    {
      loading: !_vm.canPlay,
      display: !_vm.show,
    },
  ],attrs:{"id":"kv-wrapper"}},[_c('video',{ref:"openVideo",staticClass:"bg-video",attrs:{"muted":"","autoplay":"","preload":"auto"},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }